import React from 'react';
import { AutocompleteState, BaseItem } from '@algolia/autocomplete-core';
import { BaseHit, Hit } from 'instantsearch.js';
import algoliasearchHelper from 'algoliasearch-helper';
import { SearchReducerInterface } from '@src/reducers/searchReducer';
import { ProgramCard } from '@src/remotes/ProgramCard';
import { OfferingHit } from '@src/queries/user';
import { trackProgramClick } from '@src/services/analytics';
import { setPosition } from '@src/utilities/offeringHitsUtility';
import { UserType } from '@src/typings/mfeCatalogTools';
import styles from './ProgramsItem.module.scss';

interface Props {
	planUuid: SearchReducerInterface['planUuid'];
	program: OfferingHit;
	results?: algoliasearchHelper.SearchResults<Hit<BaseHit>>;
	state: AutocompleteState<BaseItem>;
	user: UserType;
}

export const ProgramsItem: React.FC<Props> = ({ planUuid, program, results, state, user }) => {
	const handleClick = () => {
		trackProgramClick({
			position: setPosition(results.page, state.activeItemId),
			programId: program.id,
			objectId: `${program.id}-${planUuid}`,
			userUuid: user?.id,
			index: results?._rawResults[0].index,
			queryId: results?._rawResults[0].queryID,
		});
	};

	return (
		<ProgramCard
			cardClassName={styles.programCard}
			employerName={user.employer}
			isAutocomplete={true}
			offeringLocation='autocomplete'
			onClick={handleClick}
			product='catalog'
			programUuid={program.uuid}
			variation='small'
		/>
	);
};
